export var gapSizes = {
    0: '0.5rem',
    1: '0.75rem',
    2: '1rem',
    3: '1.5rem',
    4: '2rem'
};
